var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProm = function SvgProm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Prom_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m25.382 8.896-13.1 9.27a7.835 7.835 0 0 1-1.186-4.176c0-4.414 3.608-7.99 8.068-7.99a8.06 8.06 0 0 1 6.218 2.896Z",
    fill: "url(#Prom_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.54 15.682a7.855 7.855 0 0 0-1.186-4.177l-6.534 4.62-6.566 4.641-.348.248.016 8.986s8.637-5.775 11.36-7.895c2.024-1.582 3.259-3.796 3.259-6.423Z",
    fill: "url(#Prom_svg__c)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Prom_svg__b",
    x1: 21.357,
    y1: 6.32,
    x2: 13.086,
    y2: 16.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE448A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Prom_svg__c",
    x1: 24.216,
    y1: 15.528,
    x2: 11.82,
    y2: 25.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E2D177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE448A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Prom_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(6 6)",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgProm;